import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { Observable } from 'rxjs';
import { buildQueryString } from 'src/lib/utilities/api/http';
import { mapResponse } from 'src/lib/utilities/api/map-response';
import { isNullOrEmptyString } from 'src/lib/utilities/compare';
import {
	CurriculumCatalogDrilldownTypes,
	CurriculumManagerCatalogDrilldownResponseModel,
} from './curriculum-manager-catalog-drilldown.model';
import {
	CurriculumGradPlanDrilldownTypes,
	CurriculumManagerGradPlanDrilldownResponseModel,
} from './curriculum-manager-grad-plan-drilldown.model';
import {
	CurriculumManagerUserDrilldownModel,
	CurriculumStudentDrilldownTypes,
	CurriculumTeacherDrilldownTypes,
} from './curriculum-manager-user-drilldown.model';

@Injectable({
	providedIn: 'root',
})
export class CurriculumManagerService {
	constructor(private httpClient: HttpClient) {}

	public viewAssociatedStudents = (
		id: number,
		skip: number,
		take: number,
		name: string,
		type: CurriculumStudentDrilldownTypes,
	): Observable<CurriculumManagerUserDrilldownModel> => {
		let qs = buildQueryString({ take, skip });
		let student = 'students';

		if (!isNullOrEmptyString(name)) {
			qs = buildQueryString({ take, skip, name: `%25${name}%25` });
		}

		if (type === 'course' || type === 'section') {
			student = 'student';
		}

		return this.httpClient
			.get<unknown>(`/api/v1/curriculum/${type}/${id}/${student}${qs}`)
			.pipe(
				mapResponse(
					(r) => plainToInstance(CurriculumManagerUserDrilldownModel, r),
					{
						errorCode: '6820E529',
					},
				),
			);
	};

	public viewAssociatedGraduationPlans = (
		id: number,
		skip: number,
		take: number,
		title: string,
		type: CurriculumGradPlanDrilldownTypes,
	): Observable<CurriculumManagerGradPlanDrilldownResponseModel> => {
		let qs = buildQueryString({ take, skip });

		if (!isNullOrEmptyString(title)) {
			qs = buildQueryString({ take, skip, title: `%25${title}%25` });
		}

		return this.httpClient
			.get<unknown>(`/api/v1/curriculum/${type}/${id}/graduation_plans${qs}`)
			.pipe(
				mapResponse(
					(r) =>
						plainToInstance(CurriculumManagerGradPlanDrilldownResponseModel, r),
					{
						errorCode: 'E7FB0FBC',
					},
				),
			);
	};

	public viewAssociatedTeachers = (
		id: number,
		skip: number,
		take: number,
		name: string,
		type: CurriculumTeacherDrilldownTypes,
	): Observable<CurriculumManagerUserDrilldownModel> => {
		let qs = buildQueryString({ take, skip });

		if (!isNullOrEmptyString(name)) {
			qs = buildQueryString({ take, skip, name: `%25${name}%25` });
		}

		return this.httpClient
			.get<unknown>(`/api/v1/curriculum/${type}/${id}/teacher${qs}`)
			.pipe(
				mapResponse(
					(r) => plainToInstance(CurriculumManagerUserDrilldownModel, r),
					{
						errorCode: '321AA46C',
					},
				),
			);
	};

	public viewAssociatedCatalogs = (
		id: number,
		skip: number,
		take: number,
		title: string,
		type: CurriculumCatalogDrilldownTypes,
	): Observable<CurriculumManagerCatalogDrilldownResponseModel> => {
		let qs = buildQueryString({ take, skip });

		if (!isNullOrEmptyString(title)) {
			qs = buildQueryString({ take, skip, title: `%25${title}%25` });
		}

		return this.httpClient
			.get<unknown>(`/api/v1/curriculum/${type}/${id}/catalog${qs}`)
			.pipe(
				mapResponse(
					(r) =>
						plainToInstance(CurriculumManagerCatalogDrilldownResponseModel, r),
					{
						errorCode: 'E7FB0FBC',
					},
				),
			);
	};
}
